/* Diente — product page: gallery, variant picker, quantity,
   tabs, sticky add-to-cart, recommendations. */
(function () {
  'use strict';

  /* --------------------------------------------------------------- gallery */

  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-dot]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-gallery-thumb]'));
        this.index = 0;

        if (this.slides.length < 2) return;

        var prev = this.querySelector('[data-gallery-prev]');
        var next = this.querySelector('[data-gallery-next]');
        if (prev) prev.addEventListener('click', this.go.bind(this, -1));
        if (next) next.addEventListener('click', this.go.bind(this, 1));

        this.thumbs.forEach(
          function (thumb) {
            thumb.addEventListener('click', function () {
              this.goTo(Number(thumb.getAttribute('data-gallery-thumb')));
            }.bind(this));
          }.bind(this)
        );

        this.bindSwipe();

        this.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') this.go(-1);
          else if (event.key === 'ArrowRight') this.go(1);
        }.bind(this));
      }

      // 40px threshold, matching the prototype's feel.
      bindSwipe() {
        var viewport = this.querySelector('[data-gallery-viewport]');
        var startX = null;

        viewport.addEventListener(
          'touchstart',
          function (event) {
            startX = event.touches[0].clientX;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchend',
          function (event) {
            if (startX === null) return;
            var delta = event.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(delta) < 40) return;
            this.go(delta < 0 ? 1 : -1);
          }.bind(this),
          { passive: true }
        );
      }

      go(step) {
        this.goTo(this.index + step);
      }

      goTo(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = 'translateX(' + -100 * this.index + '%)';

        this.dots.forEach(
          function (dot, i) {
            dot.classList.toggle('is-active', i === this.index);
          }.bind(this)
        );

        this.thumbs.forEach(
          function (thumb, i) {
            thumb.classList.toggle('is-active', i === this.index);
            thumb.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          }.bind(this)
        );
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var gallery = root.querySelector('[data-gallery]');

  /* -------------------------------------------------------- variant picker */

  var variantData = root.querySelector('[data-product-variants]');
  if (variantData) {
    var variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      variants = null;
    }

    if (variants) {
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-product-option]'));
      var idInput = root.querySelector('[data-variant-id]');
      var addButton = root.querySelector('[data-add-button]');
      var addLabel = root.querySelector('[data-add-label]');

      var syncVariant = function () {
        var chosen = selects.map(function (select) {
          return select.value;
        });

        var match = variants.find(function (variant) {
          return chosen.every(function (value, index) {
            return variant.options[index] === value;
          });
        });

        if (!match) return;

        idInput.value = match.id;
        addButton.disabled = !match.available;
        if (addLabel && !match.available) addLabel.textContent = window.theme.strings.soldOut || addLabel.textContent;

        var priceAmount = root.querySelector('[data-product-price] .price__amount');
        if (priceAmount) priceAmount.textContent = window.Diente.formatAmount(match.price);

        var priceCompare = root.querySelector('[data-product-price] .price__compare');
        if (priceCompare) {
          if (match.compare_at_price > match.price) {
            var priceCompareValue = priceCompare.querySelector('[data-compare-value]') || priceCompare;
            priceCompareValue.textContent = window.Diente.formatAmount(match.compare_at_price);
            priceCompare.hidden = false;
          } else {
            priceCompare.hidden = true;
          }
        }

        root.querySelectorAll('[data-sticky-price]').forEach(function (el) {
          var currency = el.querySelector('span');
          el.textContent = window.Diente.formatAmount(match.price) + ' ';
          if (currency) el.appendChild(currency);
        });

        if (gallery && match.featured_media_index >= 0) gallery.goTo(match.featured_media_index);

        // Keep the URL shareable without reloading.
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      };

      selects.forEach(function (select) {
        select.addEventListener('change', syncVariant);
      });
    }
  }

  /* ------------------------------------------------------------- quantity */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-up], [data-qty-down]');
    if (!button) return;

    var wrapper = button.closest('.qty');
    var input = wrapper.querySelector('[data-qty-input]');
    var step = button.hasAttribute('data-qty-up') ? 1 : -1;
    input.value = Math.max(1, Number(input.value || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------------------- tabs */

  root.ownerDocument.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(tabs.querySelectorAll('.tabs__panel'));

    function activate(id) {
      buttons.forEach(function (button) {
        var on = button.getAttribute('data-tab') === id;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var on = panel.id === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        activate(button.getAttribute('data-tab'));
      });

      button.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = buttons[(index + 1) % buttons.length];
        else if (event.key === 'ArrowLeft') next = buttons[(index - 1 + buttons.length) % buttons.length];
        if (!next) return;

        event.preventDefault();
        next.focus();
        activate(next.getAttribute('data-tab'));
      });
    });
  });

  /* ------------------------------------------------------- sticky add-to-cart */

  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) {
    var form = root.querySelector('[data-cart-add-form]');
    var mainButton = root.querySelector('[data-add-button]');

    // Show the bar once the main buy block has scrolled out of view.
    var sentinel = root.querySelector('.product__buy');
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        },
        { rootMargin: '0px 0px -60px 0px' }
      ).observe(sentinel);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          sticky.hidden = window.scrollY <= 560;
        },
        { passive: true }
      );
    }

    sticky.addEventListener('click', function (event) {
      if (!event.target.closest('[data-sticky-add]')) return;

      var stickyQty = sticky.querySelector('[data-qty-input]');
      var mainQty = form.querySelector('[data-qty-input]');
      if (stickyQty && mainQty) mainQty.value = stickyQty.value;

      if (mainButton.disabled) return;
      form.requestSubmit ? form.requestSubmit(mainButton) : mainButton.click();
    });
  }

  /* -------------------------------------------------------- recommendations */

  var recommendations = document.querySelector('[data-recommendations]');
  if (recommendations) {
    fetch(recommendations.getAttribute('data-url'))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('.section-related');
        if (section && section.querySelector('.card')) {
          recommendations.replaceWith(section);
          document.dispatchEvent(new CustomEvent('wishlist:render'));
          document.dispatchEvent(new CustomEvent('product-carousel:render'));
        }
      })
      .catch(function () {
        /* recommendations are optional — fail quietly */
      });
  }
})();